import React from 'react';

import styled from 'styled-components';

const HomeCont = styled.div``;

export const HomePage = () => {
  return <HomeCont>Home content goes here.</HomeCont>;
};
